import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DialogService {

  visible = false;
  header = '';
  message = '';

  showError(msg: string, header: string = "Error") {
    this.message = msg;
    this.header = header;
    this.visible = true;
  }

  showSuccess(msg: string, header: string = "Success") {
    this.message = msg;
    this.header = header;
    this.visible = true;
  }

  hide() {
    this.visible = false;
  }
}
